import PageHeaderContent from '@/components/PageHeaderContent/PageHeaderContent';

export default PageHeaderContent;
